import React from "react";

import { StyledTimeInput, StyledTimeInputProps } from "./styled";

type TimeInputProps = {
  name?: string;
  inputValue?: string;
  readonly?: boolean;
  onChangeHandler?: React.ChangeEventHandler<HTMLInputElement>;
  onBlurHandler?: React.FocusEventHandler<HTMLInputElement>;
} & StyledTimeInputProps;

export const TimeInput: React.FC<TimeInputProps> = ({
  name,
  inputValue,
  onChangeHandler,
  onBlurHandler,
  readonly,
  ...styles
}) => {
  return (
    <StyledTimeInput
      name={name}
      value={inputValue}
      onChange={onChangeHandler}
      readOnly={readonly}
      onBlur={onBlurHandler}
      {...styles}
    ></StyledTimeInput>
  );
};
